module.exports = __webpack_public_path__ + "r-v3/img/write.e5995ba7.svg";